// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { primaryImageStyles } from "@steiner/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

primaryImageStyles.primaryImage = {
    centeringWrapper: {
        css: css`
            ${xScreen("lte", "xs")} {
                height: 328px;
            }
        `,
    },
    img: {
        css: css`
            ${xScreen("lte", "xs")} {
                aspect-ratio: 1/1;
            }
        `,
    },
};

primaryImageStyles.videoContainer = {
    css: css`
        margin-bottom: 8px;
        &,
        & > div {
            height: 430px;
            width: 430px;
        }
        &&&& video,
        iframe {
            cursor: pointer;
            max-height: 430px;
            min-height: 430px;
        }
    `,
};

primaryImageStyles.fullPrimaryImageModal = {
    sizeVariant: "large",
    cssOverrides: {
        modalTitle: css`
            &:after {
                display: none;
            }
        `,
        modalContent: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
            flex: 1;
        `,
        modalBody: css`
            &&& {
                height: calc(100% - 50px);
            }
        `,
    },
};

primaryImageStyles.imageCarousel = {
    mainContainer: {
        css: css`
            max-width: 420px;
            margin: 0 auto;
        `,
    },
};

primaryImageStyles.fullPrimaryImage = {
    image: {
        css: css`
            img {
                width: auto;
                max-height: 70vh;
            }
        `,
    },
    img: {
        css: css`
            width: auto;
            max-height: 70vh;
        `,
    },
    container: {
        css: css`
            display: flex;
            flex: 1;
        `,
    },
};